(() => {
  if (customElements.get('kaufnivo-buy-now')) return;
  customElements.define('kaufnivo-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.primary = this.closest('form')?.querySelector('button[name="add"]');
      if (!this.button || !this.primary) return;
      this.sync = () => {
        this.button.disabled = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true';
        this.button.setAttribute('aria-busy', String(this.primary.classList.contains('loading')));
      };
      this.onClick = () => {
        this.sync();
        if (this.button.disabled) return;
        const form = this.closest('form');
        form.dataset.mcBuyNow = 'true';
        try {
          this.primary.click();
        } finally {
          delete form.dataset.mcBuyNow;
        }
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
})();
